package com.flowyride.core.api

import kotlinx.serialization.Serializable

/** Rides saved on the signed-in rider's account. */
object FavoritesApi {
    /** GET → [FavoriteSummaryDto] list, newest first. POST [NewFavoriteDto] → 201 [FavoriteSummaryDto]. */
    const val PATH = "/api/favorites"

    /** GET → [FavoriteDto]. PATCH [RenameFavoriteDto] → [FavoriteSummaryDto]. DELETE → 204. */
    fun item(id: Long) = "$PATH/$id"
}

@Serializable
enum class FavoriteSourceDto { PLANNED, IMPORTED }

@Serializable
data class FavoriteStopDto(val name: String, val lat: Double, val lon: Double)

@Serializable
data class FavoriteSummaryDto(
    val id: Long,
    val name: String,
    val source: FavoriteSourceDto,
    val distanceMeters: Double,
    val durationSeconds: Double,
    val createdAt: Long,
)

@Serializable
data class FavoriteDto(
    val summary: FavoriteSummaryDto,
    val stops: List<FavoriteStopDto>,
    val route: RouteResponseDto,
    val preferences: RoutePreferencesDto? = null,
)

@Serializable
data class NewFavoriteDto(
    val name: String,
    val source: FavoriteSourceDto,
    val stops: List<FavoriteStopDto>,
    val route: RouteResponseDto,
    val preferences: RoutePreferencesDto? = null,
)

@Serializable
data class RenameFavoriteDto(val name: String)
